<!-- mobile devices -->
<div [class]="'banner d-flex d-md-none banner-' + type()">
    @if (backgroundImageMobile() || backgroundImage()) {
    <img
        brandOptimizedImage
        [alt]="backgroundImageMobileAltText() || backgroundImageAltText()"
        [ngSrc]="backgroundImageMobile() || backgroundImage()"
        class="optimized-image"
        fill
    />
    }
</div>
<div class="mobile-content d-block d-md-none">
    <ng-template [ngTemplateOutlet]="InlineBannerContentRef"></ng-template>
</div>

<!-- tablet devices -->
<div [class]="'banner d-none d-md-flex d-lg-none banner-' + type()">
    @if (backgroundImageTablet() || backgroundImage()) {
    <img
        brandOptimizedImage
        [alt]="backgroundImageTabletAltText() || backgroundImageAltText()"
        [ngSrc]="backgroundImageTablet() || backgroundImage()"
        class="optimized-image"
        fill
    />
    }
</div>
<div class="mobile-content d-none d-md-block d-lg-none">
    <ng-template [ngTemplateOutlet]="InlineBannerContentRef"></ng-template>
</div>

<!-- desktop devices -->
<div [class]="'banner d-none d-lg-flex banner-' + type()">
    @if (backgroundImage()) {
    <img
        brandOptimizedImage
        [alt]="backgroundImageAltText()"
        [ngSrc]="backgroundImage()"
        class="optimized-image"
        fill
    />
    }

    <div class="d-none w-100 d-lg-flex">
        <ng-template [ngTemplateOutlet]="InlineBannerContentRef"></ng-template>
    </div>
</div>

@if (modalVideoId() && isBrowser) {
<brand-modal
    (onClose)="closeModal($event)"
    [id]="modalVideoId()"
    modalDialogClass="modal-video modal-dialog-centered modal-max-width"
    modalContentClass="bg-transparent"
>
    @if (videoLoaded) {
    <brand-video [videoData]="videoUrl"> </brand-video>
    }
</brand-modal>
}

<!--INLINE BANNER CONTENT TEMPLATE-->
<ng-template #InlineBannerContentRef>
    <div class="container-fluid p-0">
        <div
            [ngClass]="[
                type() === 'left' ? 'justify-content-start' : '',
                type() === 'right' ? 'justify-content-end' : ''
            ]"
            class="row"
        >
            <div
                class="markdown col-12 col-lg-7 col-xl-6 align-content-start text-left inline-banner-content"
            >
                <div
                    [ngClass]="colorClass()"
                    class="my-lg-4 mx-lg-4 py-4 px-2 px-md-4 px-lg-3 px-xl-4 overflow-hidden"
                >
                    <ng-template [ngTemplateOutlet]="contentRef"></ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!--TEMPLATE PARTIALS-->
<ng-template #contentRef>
    @if (headingValue() === 1 || !headingValue()) {
    <h1 #inlineBannerHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h1>
    } @if (headingValue() === 2) {
    <h2 #inlineBannerHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h2>
    } @if (headingValue() === 3) {
    <h3 #inlineBannerHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h3>
    } @if (headingValue() === 4) {
    <h4 #inlineBannerHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h4>
    } @if (headingValue() === 5) {
    <h5 #inlineBannerHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h5>
    } @if (description()) {
    <div
        #inlineBannerDescription
        [innerHtml]="description()"
        class="mt-1"
    ></div>
    }

    <div class="cta">
        @for (action of actionOrder(); track action) { @switch (action) { @case
        ('video') { @if (modalVideoId()) {
        <button
            #inlineBannerModalLink
            [ngClass]="buttonClass() ? buttonClass() : 'btn-link'"
            (click)="openModal(modalVideoId())"
            class="icon-link banner--modal-btn p-0 mt-4"
        >
            <span class="icon-link-icon">
                <img
                    [src]="'GLOBAL_WATCH-VIDEO_PLAY_ICON_URL' | translate"
                    [alt]="'GLOBAL_WATCH-VIDEO_PLAY_ICON_ALT_TEXT' | translate"
                    class="bi play-icon"
                />
            </span>

            <span [innerHtml]="'GLOBAL_WATCH-VIDEO_TEXT' | translate"> </span>
        </button>
        } } @case ('button') { @if (buttonText() && buttonUrl()) {
        <div class="banner-button mt-4">
            <a
                #inlineBannerButton
                [brandHref]="buttonUrl()"
                [innerHtml]="buttonText()"
                class="btn btn-primary"
            >
            </a>
        </div>
        } } @case ('link') { @if (linkText() && linkUrl()) {
        <div class="banner-link mt-4">
            <a
                #inlineBannerLink
                [brandHref]="linkUrl()"
                class="icon-link banner--link p-0"
            >
                <span [innerHtml]="linkText()"></span>
                <span class="icon-link-icon">
                    <img
                        [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                        [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                        class="bi arrow-icon"
                    />
                </span>
            </a>
        </div>
        } } } }
        <ng-content></ng-content>
    </div>
</ng-template>

<ng-template #headerRef>
    @if (!isHidden && subheading() && subheading() !== '') {
    <small [innerHtml]="subheading()" class="subtitle d-block"></small>
    } @if (heading()) {
    <span [innerHtml]="heading()"></span>
    }
</ng-template>
